import { FormattedMessage } from 'react-intl';

import { Gallery } from '@sorare/core/src/atoms/icons/Gallery';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { Switch } from '@sorare/core/src/components/search/Switch';
import { useFacet } from '@sorare/core/src/contexts/graphql-search';
import { useVirtualToggle } from '@sorare/core/src/hooks/useVirtualToggle';
import { useVirtualToggleManager } from '@sorare/core/src/hooks/useVirtualToggleManager';
import type { FilterWidget } from '@sorare/core/src/lib/filters';
import { VIRTUAL_TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { Toggle } from '#src/searchCards/Toggle/index.tsx';

const DUPLICATE_FILTER = VIRTUAL_TOGGLE_FILTERS.duplicateFilter;
const DUPLICATE_VALUE = 'player.slug';

const DuplicateFilterComponent = () => {
  const setVirtualToggle = useVirtualToggleManager();
  const { currentRefinement } = useVirtualToggle<string>({
    name: DUPLICATE_FILTER.name,
  });
  return (
    <Toggle icon={<Gallery />}>
      <Switch
        checked={!!currentRefinement}
        onChange={event => {
          setVirtualToggle({
            [DUPLICATE_FILTER.name]: event.target.checked
              ? DUPLICATE_VALUE
              : false,
          });
        }}
        label={
          <BodyM bold>
            <FormattedMessage {...DUPLICATE_FILTER.label} />
          </BodyM>
        }
      />
    </Toggle>
  );
};

const BackendDuplicateFilterComponent = () => {
  const {
    refine,
    value: [value],
  } = useFacet('dk');

  return (
    <Toggle icon={<Gallery />}>
      <Switch
        checked={!!value}
        onChange={event => {
          refine(() => (event.target.checked ? [DUPLICATE_VALUE] : []));
        }}
        label={
          <BodyM bold>
            <FormattedMessage {...DUPLICATE_FILTER.label} />
          </BodyM>
        }
      />
    </Toggle>
  );
};

export const DuplicateFilter: FilterWidget = {
  key: 'duplicatedKey',
  type: 'toggle',
  attribute: '',
  Component: DuplicateFilterComponent,
};

export const BackendDuplicateFilter: FilterWidget = {
  key: 'duplicateKey',
  type: 'toggle',
  attribute: '',
  Component: BackendDuplicateFilterComponent,
};
